/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Scuola } from './scuola';
import { ServizioMensaDovutoDaAnnullareDTO } from './servizio-mensa-dovuto-da-annullare-dto';
import { ServizioMensaStudenteGenitore } from './servizio-mensa-studente-genitore';
import { ServizioMensaStudenteSospensione } from './servizio-mensa-studente-sospensione';


export interface ServizioMensaStudenteDTO { 
    id?: string;
    nome?: string;
    cognome?: string;
    codice_fiscale?: string;
    data_nascita?: string;
    comune_nascita?: string;
    provincia_nascita?: string;
    cittadinanza?: string;
    non_autosufficiente?: boolean;
    classe?: string;
    sezione?: string;
    dieta?: string;
    religione?: string;
    note?: string;
    is_esente?: boolean;
    is_sospeso?: boolean;
    motivo_esenzione?: string;
    identificativo_menu_extra?: string;
    scuola?: Scuola;
    genitore?: ServizioMensaStudenteGenitore;
    codice_pratica?: string;
    sospensione?: ServizioMensaStudenteSospensione;
    dovuti_da_annullare?: Array<ServizioMensaDovutoDaAnnullareDTO>;
}

